// eslint-disable-next-line no-script-url
const BLOCKLISTED_PROTOCOLS = ['javascript:', 'vbscript:', 'data:'];

// eslint-disable-next-line no-control-regex
const STRIPPABLE_HREF_CHARS_REGEX = /[\x00-\x1F\x7F\s]/g;
const hasBlocklistedProtocol = node => {
  if (BLOCKLISTED_PROTOCOLS.includes(node.protocol)) {
    return true;
  }
  const rawHref = node.getAttribute('href') || '';
  const normalizedHref = rawHref.replace(STRIPPABLE_HREF_CHARS_REGEX, '').toLowerCase();
  return BLOCKLISTED_PROTOCOLS.some(protocol => normalizedHref.startsWith(protocol));
};

// Sanitize any anchor tags that are not external links. This prevents any XSS, see
// https://issues.hubspotcentral.com/browse/HMSP-2657
// https://issues.hubspotcentral.com/browse/HMSP-4160
export const removeInvalidAnchorProtocols = ({
  node
}) => {
  if (!node || !node.href && !node.getAttribute('href') || node.nodeName.toUpperCase() !== 'A' || !hasBlocklistedProtocol(node)) {
    return null;
  }
  const replacementSpan = document.createElement('span');
  replacementSpan.innerText = node.innerText;
  return {
    node: replacementSpan
  };
};